import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "sec-main appointmentP-main" }
const _hoisted_3 = { class: "container-lg" }
const _hoisted_4 = { class: "col-sm-10 mx-auto" }
const _hoisted_5 = {
  style: {"--bs-breadcrumb-divider":"'>'"},
  "aria-label": "breadcrumb"
}
const _hoisted_6 = { class: "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("li", {
  class: "breadcrumb-item active",
  "aria-current": "page"
}, "創業工具 - 預約諮詢", -1)
const _hoisted_9 = { class: "row head-row" }
const _hoisted_10 = { class: "col-12 col-sm-10 mx-auto" }
const _hoisted_11 = { class: "appointment-board bg-gray" }
const _hoisted_12 = { class: "appointment-board-wrapper" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 n text-primary mb-4" }, "預約諮詢", -1)
const _hoisted_14 = { class: "mb-5" }
const _hoisted_15 = { class: "mb-4" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "mb-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "qaType",
  class: "form-label text-black mb-4"
}, "問題分類", -1)
const _hoisted_20 = { class: "form-check form-check-inline" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "qaType1"
}, "一般通識", -1)
const _hoisted_22 = { class: "form-check form-check-inline" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "qaType2"
}, "創業資金", -1)
const _hoisted_24 = { class: "form-check form-check-inline" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "qaType3"
}, "工商登記", -1)
const _hoisted_26 = { class: "form-check form-check-inline" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "qaType4"
}, "其他", -1)
const _hoisted_28 = { class: "mb-4 mb-md-5" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "qaMsg",
  class: "form-label text-black mb-4"
}, "諮詢問題簡述(300字以內)", -1)
const _hoisted_30 = { class: "fccc" }
const _hoisted_31 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_title = _resolveDirective("title")!
  const _directive_body_class = _resolveDirective("body-class")!

  return _withDirectives((_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_router_link, {
                  to: "/",
                  title: "首頁",
                  class: "foo: false"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("首頁")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_8
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Form, { onSubmit: _ctx.submit }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                          "data-vv-as": "Address Line 1",
                          class: "form-control",
                          type: "text",
                          placeholder: "姓名",
                          "aria-label": "Username",
                          required: "",
                          "aria-invalid": "true",
                          "aria-describedby": ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.name]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.name.errorMessage), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.mobile) = $event)),
                          class: "form-control",
                          type: "tel",
                          placeholder: "電話/手機",
                          "aria-label": "Usertel",
                          required: "",
                          "aria-invalid": "true",
                          "aria-describedby": ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.mobile]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.mobile.errorMessage), 1)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                          class: "form-control",
                          type: "email",
                          placeholder: "Email",
                          "aria-label": "Useremail",
                          required: "",
                          "aria-invalid": "true",
                          "aria-describedby": ""
                        }, null, 512), [
                          [_vModelText, _ctx.form.email]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.email.errorMessage), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.category) = $event)),
                            class: "form-check-input",
                            type: "radio",
                            name: "qaType",
                            id: "qaType1",
                            value: "GENERAL"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.category]
                          ]),
                          _hoisted_21
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.category) = $event)),
                            class: "form-check-input",
                            type: "radio",
                            name: "qaType",
                            id: "qaType2",
                            value: "FUND"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.category]
                          ]),
                          _hoisted_23
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.category) = $event)),
                            class: "form-check-input",
                            type: "radio",
                            name: "qaType",
                            id: "qaType3",
                            value: "REGISTRATION"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.category]
                          ]),
                          _hoisted_25
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.category) = $event)),
                            class: "form-check-input",
                            type: "radio",
                            name: "qaType",
                            id: "qaType4",
                            value: "OTHER"
                          }, null, 512), [
                            [_vModelRadio, _ctx.form.category]
                          ]),
                          _hoisted_27
                        ])
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.category.errorMessage), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.content) = $event)),
                        class: "form-control",
                        id: "qaMsg",
                        rows: "13"
                      }, null, 512), [
                        [_vModelText, _ctx.form.content]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.content.errorMessage), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "btn-primay filled",
                        disabled: _ctx.disableButton
                      }, "送出", 8, _hoisted_31)
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ])
          ])
        ])
      ])
    ])
  ])), [
    [_directive_title, '預約諮詢'],
    [_directive_body_class, 'appointmentP']
  ])
}